module.exports = __webpack_public_path__ + "1ced08cecbb2327eb7a296f52dd2c686.jpg";


//////////////////
// WEBPACK FOOTER
// ./2017-04-08-harrison-yoga/2.jpg
// module id = 611
// module chunks = 0